<template>
  <Modal title="上课反馈审批" v-model="visible" :width="640">
    <Form ref="recordForm" class="form"
      :model="feedBackParamData" :rules="recordRule"
      :label-width="90">
      <Row v-if="['加开固定时间', '加开临时时间', '上课反馈'].includes(feedBackParamData.bizType)">
        <Col :span="22">
          <Form-item label="老师ID、姓名">
            <label>{{ feedBackParamData.tchId }} {{ feedBackParamData.tchName }}</label>
          </Form-item>
        </Col>
      </Row>
      <Row v-if="['体验课上课要求', '上课反馈'].includes(feedBackParamData.bizType)">
        <Col :span="22">
          <Form-item label="学生ID、姓名">
            <label>{{ feedBackParamData.uid }} {{ feedBackParamData.stdName }}</label>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="反馈类型">
            <label>{{ feedBackParamData.bizType }}</label>
            <Button type="primary" @click="showClassRequirement" v-if="feedBackParamData.bizType === '体验课上课要求'">查看上课要求</Button>
          </Form-item>
        </Col>
      </Row>
      <Row v-if="showClassRequirementModal">
        <Col :span="22">
         <Table class="compact" size="small" :columns="classRequirementColumn" :data="classRequirementList"></Table>
        </Col>
      </Row>
      <Row style="margin-top: 10px;">
        <Col :span="22">
          <Form-item label="反馈内容"  prop="feedContent" v-if="!['加开固定时间', '加开临时时间'].includes(feedBackParamData.bizType)">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
              placeholder="长度不要超过100个字符"
              v-model="feedBackParamData.feedContent"
              :disabled="feedBackParamData.bizType === '体验课上课要求'"></Input>
          </Form-item>
          <Form v-if="feedBackParamData.bizType === '加开固定时间'" ref="timeForm1" class="form" :label-width="90"
            :model="timeParam" :rules="timeRule1">
            <Row>
              <Col :span="26" >
                <Form-item label="选择买断时间" prop="openedTime">
                  <Row :gutter="12">
                    <Col :span="4">
                      <Form-item prop="week">
                        <Select placeholder="星期" v-model="timeParam.week" transfer>
                          <Option v-for="item in $constant.week"
                            :value="item.code" :key="item.code">{{ item.text }}</Option>
                        </Select>
                      </Form-item>
                    </Col>
                    <Col :span="5">
                      <Form-item prop="startTime">
                        <Time-picker format="HH:mm" placeholder="开始时间" :clearable="false"
                          :steps="[1, 5]" :value="timeParam.startTimeStr"
                          @on-change="onChangeStratTime"></Time-picker>
                        </Form-item>
                    </Col>
                    <Col :span="1"></Col>
                    <Col :span="5">
                      <Form-item prop="endTime">
                        <Time-picker format="HH:mm" placeholder="结束时间" :clearable="false"
                          :steps="[1, 5]" :value="timeParam.endTimeStr"
                          @on-change="onChangeEndTime"></Time-picker>
                      </Form-item>
                    </Col>
                    <i-col :span="6" >
                      <Form-item prop="useDate" >
                        <Date-picker type="date" format="yyyy-MM-dd" placeholder="生效日期"
                                    @on-change="onChangeUseDate" :clearable="false" :value="timeParam.useDateStr"></Date-picker>
                      </Form-item>
                    </i-col>
                    <Col :span="2">
                      <Button type="info" @click="addOpenedTime1">添加</Button>
                    </Col>
                  </Row>
                </Form-item>
              </Col>
            </Row>
          </Form>
          <Form v-if="feedBackParamData.bizType === '加开固定时间'" ref="timeListForm1" class="form" :label-width="90"
            :model="{}" :rules="timeListRule1">
            <Row>
              <Col :span="22" >
                <Form-item label="已选择时间" prop="openedTimeList" >
                  <Row >
                    <div v-for="(item, index) in openedTimeList" :key="item.week">
                      <Col offset="1" span="19">
                        <label ><b>时间：{{ item.weekStr }} {{ item.startTimeStr }} - {{ item.endTimeStr }} , &nbsp;&nbsp; 生效日期：{{ item.useDateStr }}</b></label>
                      </Col>
                      <Col span="3">
                        <Button type="error" size="small" @click="removeOpenedTime(index)">删除</Button>
                      </Col>
                    </div>
                  </Row>
                </Form-item>
              </Col>
            </Row>
          </Form>
          <Form v-if="feedBackParamData.bizType === '加开临时时间'" ref="timeForm2" class="form" :label-width="100"
            :model="timeParam" :rules="timeRule2">
            <Row>
              <Col :span="22" >
                <Form-item label="选择上课时间" prop="openedTime">
                  <Row :gutter="12">
                    <Col :span="8">
                      <Form-item prop="day">
                        <Date-picker type="date" placeholder="选择日期"
                          format="yyyy-MM-dd" :value="timeParam.dayStr"
                          @on-change="onChangeDate" :onfocus="false"></Date-picker>
                      </Form-item>
                    </Col>
                    <Col :span="6">
                      <Form-item prop="startTime">
                        <Time-picker format="HH:mm" placeholder="开始时间" :clearable="false"
                          :steps="[1, 5]" :value="timeParam.startTimeStr"
                          @on-change="onChangeStratTime" :onfocus="false"></Time-picker>
                        </Form-item>
                    </Col>
                    <Col :span="1"></Col>
                    <Col :span="6">
                      <Form-item prop="endTime">
                        <Time-picker format="HH:mm" placeholder="结束时间" :clearable="false"
                          :steps="[1, 5]" :value="timeParam.endTimeStr"
                          @on-change="onChangeEndTime" :onfocus="false"></Time-picker>
                      </Form-item>
                    </Col>
                    <Col :span="3">
                      <Button type="info" @click="addOpenedTime2">添加</Button>
                    </Col>
                  </Row>
                </Form-item>
              </Col>
            </Row>
          </Form>
          <Form v-if="feedBackParamData.bizType === '加开临时时间'" ref="timeListForm2" class="form" :label-width="100"
            :model="{}" :rules="timeListRule2">
            <Row>
              <Col :span="24" >
                <Form-item label="已选择时间" prop="openedTimeList" >
                  <Row >
                    <div v-for="(item, index) in openedTimeList" :key="index">
                      <Col offset="1" span="8">
                        <label ><b>{{ item.dayStr }} {{ item.startTimeStr }}-{{ item.endTimeStr }}</b></label>
                      </Col>
                      <Col span="2">
                        <Button type="error" size="small" @click="removeOpenedTime(index)">删除</Button>
                      </Col>
                    </div>
                  </Row>
                </Form-item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row v-if="feedBackParamData.feedRemark">
        <Col :span="22">
          <Form-item label="外教留言">
            <label>{{ feedBackParamData.feedRemark }}</label>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="反馈时间">
            <label>{{ feedBackParamData.fromUser }} {{ feedBackParamData.createTime }}</label>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="审批状态">
            <RadioGroup v-model="feedBackParamData.auditStatus">
              <Radio :label=0 >暂不处理</Radio>
              <Radio :label=1>通过</Radio>
              <Radio :label=2>不通过</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="审批意见" prop="auditRemark">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 15}" :maxlength="500"
              placeholder="长度不要超过500个字符"
              v-model="feedBackParamData.auditRemark"></Input>
          </Form-item>
        </Col>
      </Row>
      <Row v-if="feedBackParamData.bizType !== '开绑定权限' && feedBackParamData.bizType !== '开临时约课权限'">
        <Col :span="22">
          <Form-item label="是否反馈外教">
            <RadioGroup v-model="feedBackParamData.showTch">
              <Radio :label=1>是</Radio>
              <Radio :label=0>否</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="add">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'LessonFeedbackDealModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      feedBackParamData: {
        type: Object,
        default: () => {
          return {
            uid: '',
            stdName: '',
            tchId: '',
            tchName: '',
            bizType: '',
            fromUser: '',
            createTime: '',
            feedContent: '',
            auditStatus: '',
            auditRemark: '',
            showTch: false,
            feedRemark: '',
          }
        }
      },
      timeList: {
        type: Array,
        default: () => {
          return []
        }
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let self = this
      return {
        showClassRequirementModal: false,
        classRequirementList: [],
        visible: this.value,
        auditParam: {
          id: '',
          auditStatus: '',
          auditRemark: '',
          showTch: false,
          feedContent: ''
        },
        loadingAdd: false,
        recordRule: {
          feedContent: [
            { type: 'string', required: true, message: '请填写反馈内容', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
          auditRemark: [
            { type: 'string', required: true, message: '请填写审批意见', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        },
        timeParam: {
          week: null,
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          useDateStr: '',
          day: '',
        },
        openedTimeList: [],
        timeRule1: {
          week: [
            { type: 'integer', required: true, message: '请选择星期' }
          ],
          startTime: [
            { type: 'integer', required: true, message: '请选择开始时间' },
            { validator (rule, value, callback, source, options) {
              let endTime = self.timeParam.endTime
              let errors = []
              if (endTime !== '' && value >= endTime) {
                errors.push('开始时间应在结束时间之前 ')
              }
              callback(errors)
            } }
          ],
          endTime: [
            { type: 'integer', required: true, message: '请选择结束时间' }
          ],
          useDate: [
            { type: 'integer', required: true, message: '请选择有效日期' }
          ],
          openedTime: [
            { validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let week = self.timeParam.week
              let startTime = self.timeParam.startTime
              let endTime = self.timeParam.endTime
              if (week === '' || startTime === '' || endTime === '' ||
                startTime >= endTime) {
                return
              }
              let errors = []
              openedTimeList.forEach(element => {
                let tmpWeek = element.week
                let tmpStratTime = element.startTime
                let tmpEndTime = element.endTime
                if (week === tmpWeek &&
                  ((tmpStratTime < startTime && tmpEndTime > startTime) ||
                  (tmpStratTime < endTime && tmpEndTime > endTime) ||
                  (tmpStratTime >= startTime && tmpEndTime <= endTime))) {
                  errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' +
                    element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突')
                }
              })
              callback(errors)
            } }
          ],
        },
        timeListRule1: {
          openedTimeList: [
            { validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let errors = []
              if (openedTimeList.length <= 0) {
                errors.push('请添加时间')
              }
              callback(errors)
            } }
          ]
        },
        timeRule2: {
          day: [
            { type: 'integer', required: true, message: '请选择日期' }
          ],
          startTime: [
            { type: 'integer', required: true, message: '请选择开始时间' },
            { validator (rule, value, callback, source, options) {
              let endTime = self.timeParam.endTime
              let errors = []
              if (endTime !== '' && value >= endTime) {
                errors.push('开始时间应在结束时间之前 ')
              }
              callback(errors)
            } }
          ],
          endTime: [
            { type: 'integer', required: true, message: '请选择结束时间' }
          ],
          openedTime: [
            { validator (rule, value, callback, source, options) {
              let day = self.timeParam.day
              let startTime = self.timeParam.startTime
              let errors = []
              let nowTime = new Date().getTime() / 1000
              if (day !== '' && startTime !== '' && nowTime >= (day + startTime)) {
                errors.push('开始时间应在当前时间之后')
                callback(errors)
                return
              }
              let openedTimeList = self.openedTimeList
              let endTime = self.timeParam.endTime
              if (day === '' || startTime === '' || endTime === '' ||
                startTime >= endTime) {
                return
              }
              openedTimeList.forEach(element => {
                let tmpDay = element.day
                let tmpStratTime = element.startTime
                let tmpEndTime = element.endTime
                if (day === tmpDay &&
                  ((tmpStratTime < startTime && tmpEndTime > startTime) ||
                  (tmpStratTime < endTime && tmpEndTime > endTime) ||
                  (tmpStratTime >= startTime && tmpEndTime <= endTime))) {
                  errors.push('添加的时间与 ' + element.dayStr + ' ' +
                    element.startTimeStr + '-' + element.endTimeStr + ' 冲突')
                }
              })
              callback(errors)
            } }
          ],
        },
        timeListRule2: {
          openedTimeList: [
            { validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let errors = []
              if (openedTimeList.length <= 0) {
                errors.push('请添加时间')
              }
              callback(errors)
            } }
          ]
        },
        classRequirementColumn: [
          {
            title: '上课要求',
            key: 'content'
          },
          {
            title: '上课要求en',
            key: 'contentEn'
          }
        ]
      }
    },
    mounted () {
      let self = this
      console.log(self.feedBackParamData)
      if(['加开固定时间', '加开临时时间'].includes(self.feedBackParamData.bizType)) {
        this.openedTimeList = JSON.parse(self.feedBackParamData.feedContent)
      }else{
        this.openedTimeList = []
      }
    },
    methods: {
      showClassRequirement () {
        let self = this
        self.$http.get('/stageReport/user-require-list?uid=' + this.feedBackParamData.uid).then(function (res) {
          if (res && res.status === 'ok') {
            self.classRequirementList = res.data
            self.showClassRequirementModal = true
          }
        })
      },
      addOpenedTime1 () {
        let week = this.timeParam.week
        let startTime = this.timeParam.startTime
        let endTime = this.timeParam.endTime
        let useDate = this.timeParam.useDate
        if (!week || startTime === '' || endTime === '' || useDate === '') {
          this.$Message.warning('请完善时间信息')
          return
        }
        if (startTime >= endTime) {
          this.$Message.warning('开始时间应在结束时间之前')
          return
        }
        // 冲突检测
        let conflict = this.openedTimeList.some(element => {
          return week === element.week &&
            ((element.startTime < startTime && element.endTime > startTime) ||
            (element.startTime < endTime && element.endTime > endTime) ||
            (element.startTime >= startTime && element.endTime <= endTime))
        })
        if (conflict) {
          this.$Message.warning('添加的时间与已选时间冲突')
          return
        }
        let openedTime = {}
        openedTime.week = week
        openedTime.weekStr = this.$constant.weekZh[week]
        openedTime.startTime = startTime
        openedTime.startTimeStr = this.timeParam.startTimeStr
        openedTime.endTime = endTime
        openedTime.endTimeStr = this.timeParam.endTimeStr
        openedTime.useDate = useDate
        openedTime.useDateStr = this.timeParam.useDateStr
        this.openedTimeList.push(openedTime)
      },
      addOpenedTime2 () {
        let day = this.timeParam.day
        let startTime = this.timeParam.startTime
        let endTime = this.timeParam.endTime
        if (day === '' || startTime === '' || endTime === '') {
          this.$Message.warning('请完善时间信息')
          return
        }
        if (startTime >= endTime) {
          this.$Message.warning('开始时间应在结束时间之前')
          return
        }
        let nowTime = new Date().getTime() / 1000
        if (nowTime >= (day + startTime)) {
          this.$Message.warning('开始时间应在当前时间之后')
          return
        }
        // 冲突检测
        let conflict = this.openedTimeList.some(element => {
          return day === element.day &&
            ((element.startTime < startTime && element.endTime > startTime) ||
            (element.startTime < endTime && element.endTime > endTime) ||
            (element.startTime >= startTime && element.endTime <= endTime))
        })
        if (conflict) {
          this.$Message.warning('添加的时间与已选时间冲突')
          return
        }
        let openedTime = {}
        openedTime.day = day
        openedTime.dayStr = this.timeParam.dayStr
        openedTime.startTime = startTime
        openedTime.startTimeStr = this.timeParam.startTimeStr
        openedTime.endTime = endTime
        openedTime.endTimeStr = this.timeParam.endTimeStr
        this.openedTimeList.push(openedTime)
      },
      removeOpenedTime (index) {
        this.openedTimeList.splice(index, 1)
      },
      onChangeDate (val) {
        this.timeParam.dayStr = val
        this.timeParam.day = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'))
      },
      onChangeStratTime (val) {
        this.timeParam.startTime = this.$dateUtil.getSecondByHm(val)
        this.timeParam.startTimeStr = val
      },
      onChangeEndTime (val) {
        this.timeParam.endTime = this.$dateUtil.getSecondByHm(val)
        this.timeParam.endTimeStr = val
      },
      onChangeUseDate (val) {
        this.timeParam.useDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'))
        this.timeParam.useDateStr = val
      },
      add () {
        let self = this
        if (['加开固定时间', '加开临时时间'].includes(self.feedBackParamData.bizType) && self.openedTimeList.length === 0) {
          self.$Message.warning('请添加时间')
          return
        }
        self.loadingAdd = true
        self.$refs.recordForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingAdd = false
            return
          }
          self.auditParam.id = self.feedBackParamData.id
          self.auditParam.auditStatus = self.feedBackParamData.auditStatus
          self.auditParam.auditRemark = self.feedBackParamData.auditRemark
          self.auditParam.showTch = self.feedBackParamData.showTch === 1 ? true : false
          if(['加开固定时间', '加开临时时间'].includes(self.feedBackParamData.bizType)) {
            self.auditParam.feedContent = JSON.stringify(self.openedTimeList)
          }else{
            self.auditParam.feedContent = self.feedBackParamData.feedContent
          }
          self.$http.post('/stageReport/fm-message-audit', self.auditParam).then(function (res) {
            self.loadingAdd = false
            if (res && res.status === 'ok') {
              self.successCallback()
              self.$Message.success('审批成功!')
              self.visible = false
              self.openedTimeList = []
              return
            }
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.auditParam.auditRemark = ''
        }
        this.$emit('input', val)
      },
      timeList (val) {
        if (val) {
          this.openedTimeList = val
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LessonFeedbackDealModal.vue?eb961a84